/**
 * DashboardActivitiesListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DashboardActivitiesListReq
 */
export interface DashboardActivitiesListReq {
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 员工ID */
  staff_id?: any
  /** 操作类型 */
  action?: string
  /** 目标类型 */
  target?: string
  /** 开始时间（毫秒时间戳） */
  start_time?: number
  /** 结束时间（毫秒时间戳） */
  end_time?: number
}

/**
 * DashboardActivitiesListReq Schema
 */
export const DashboardActivitiesListReqSchema: SchemaDefinition = {
  properties: {
    page: {
      default: 1,
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      default: 20,
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    staff_id: {
      description: '员工ID',
      format: 'string',
      type: 'staff',
      label: '员工ID',
    },
    action: {
      description: '操作类型',
      format: 'string',
      type: 'string',
      label: '操作类型',
    },
    target: {
      description: '目标类型',
      format: 'string',
      type: 'string',
      label: '目标类型',
    },
    start_time: {
      description: '开始时间（毫秒时间戳）',
      format: 'int64',
      type: 'integer',
      label: '开始时间',
    },
    end_time: {
      description: '结束时间（毫秒时间戳）',
      format: 'int64',
      type: 'integer',
      label: '结束时间',
    },
  },
  type: 'object',
}
